import React, { useEffect, useState } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import {
  getBots,
  getIndicators,
  getRentalBots,
  getSubscription
} from "../../actions/bot-action";
import { Row, Col, Card, Button } from "react-bootstrap";
import "./Bots.scss";
import BotTab from "./BotTab";
import ProfitPanel from "./ProfitPanel";
import CreateBotModal from "./CreateBotModal";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import BotDetail from "./bot-detail/BotDetail";
import ContentContainer from "../common/ContentContainer";
import DailyPnlPanel from "../dashboard/DailyPnlPanel";
import CustomPagination from "../common/CustomPagination";
import { getBotDetail } from "../../actions/bot-action";
import useLoading from "../hooks/useLoading";
import Loading from "../common/Loading";
import {
  resetBotConfig,
  updateEditBotConfig,
  updatePresetConfig,
  updateCopyBotConfig,
  updateEditRentBotConfig
} from "../../actions/create-bot-action";
import { BotType, CreateBotModalType } from "../../Const";
import { CHANGE_BOT_TYPE } from "../../actions/create-bot-type";
import { CLOSE_TOUR_SIMPLE_BOT_WINDOW, HIDE_GRAPH, SET_JOYRIDE_STEP, SET_TOUR_SIMPLE_BOT_WINDOW } from "../../actions/types";
import BotTabRent from "./BotTabRent";
import CreateBotFromRentModal from "../marketplace/bots/CreateBotFromRentModal";
import BotFilterPanel from "./BotFilterPanel";
import { useTranslation } from "react-i18next";

const Bots = (props) => {
  const {
    getBots,
    getSubscription,
    updateEditBotConfig,
    updateCopyBotConfig,
    updateEditRentBotConfig,
    resetBotConfig,
    updatePresetConfig,
    getIndicators,
    getBotDetail,
    getRentalBots
  } = props;
  const { t } = useTranslation()
  const [sort, setSort] = useState("apy");
  const [orderBy, setOrderBy] = useState("desc");
  const { search } = useLocation();
  const history = useHistory();
  const pageNum=1;
  const tabTitles = [t("active"), t("inactive"),t("rent")];
  const tourClasses = ["active-bots-tour", "inactive-bots-tour","rented-bots-tour"];
  const itemsPerPage = 10;
  const [createBotModalType, setCreateBotModalType] = useState(
    CreateBotModalType.notShow
  );
  const [showEditRentBotModal,setShowEditRentBotModal] = useState(false)
  const [checkClickEdit,setCheckClickEdit] = useState(false)
  const [showBotDetail, setShowBotDetail] = useState(-1);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedTab, getSelectedTab] = useState('active');
  const [botId, setBotId] = useState(-1);

  var bots = useSelector((state) => state.bots.bots) || [];
  var rents = useSelector((state) => state.bots.rents) || [];
  const tourSimpleBotWindow = useSelector((state) => state.settings.tourSimpleBotWindow);
  const closeTourSimpleBotWindow = useSelector((state) => state.settings.closeTourSimpleBotWindow);
  const [setLoading, bindLoading] = useLoading(false);

  const selectedExchangeId =
    useSelector((state) => state.settings.selectedExchangeId) || 0;
  const hideGraph = useSelector((state) => state.bots.hideGraph) || false;
  bots = bots.filter((item) => {
    return selectedExchangeId == item.exchange_id;
  });
  // const activeBots = bots.filter((bot) => bot.status === "active");
  // const inactiveBots = bots.filter((bot) => bot.status === "inactive");
  // const activeBots = bots;
  // const inactiveBots = bots;
  const totalBots = useSelector((state) => state.bots.totalBots) || 0;
  const startItem = useSelector((state) => state.bots.startItem) || 1;
  const totalRentBots = useSelector((state) => state.bots.totalRentBots) || 0;
  const startItemRent = useSelector((state) => state.bots.startItemRent) || 1;

  const query = queryString.parse(search);
  const dispatch = useDispatch();

  const clickShowGraph = () =>
    dispatch({
      type: HIDE_GRAPH,
      payload: false,
    });
  
  const showCreateBotModal = (botType) => {
    setCreateBotModalType(CreateBotModalType.newBot);
    dispatch({
      type: CHANGE_BOT_TYPE,
      payload: botType ?? BotType.simple,
    });
  };
  useEffect(()=>{
    if(tourSimpleBotWindow){
      showCreateBotModal(BotType.simple)
      dispatch({
        type: SET_TOUR_SIMPLE_BOT_WINDOW,
        payload: false,
      });
    }
  },[tourSimpleBotWindow])
  useEffect(()=>{
    if(closeTourSimpleBotWindow){
      setCreateBotModalType(CreateBotModalType.notShow);
      dispatch({
        type: CLOSE_TOUR_SIMPLE_BOT_WINDOW,
        payload: false,
      });
    }
  },[closeTourSimpleBotWindow])
  
  useEffect(() => {
    if (botId != -1) {
      setLoading(true);
      getBotDetail(botId)
        .then(() => {
          updateCopyBotConfig(botId);
          setCreateBotModalType(CreateBotModalType.newBot);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          //toast.error(err);
        });
    }
  }, [botId]);
  useEffect(() => {
    getBots(selectedExchangeId,itemsPerPage,pageNum,selectedTab,orderBy,sort);
    getRentalBots(selectedExchangeId,itemsPerPage,pageNum,selectedTab,orderBy,sort);
    getIndicators();
    resetBotConfig();
  }, [sort,orderBy,selectedExchangeId]);

  useEffect(() => {
    getSubscription();
  }, []);

  useEffect(() => {
    if (search != "") {
      if (query.edit) {
       if(checkClickEdit){
         //updateEditBotConfig();
        //setCreateBotModalType(CreateBotModalType.editBot);
        setCreateBotModalType(CreateBotModalType.notShow);
        onShowBotEdit(query.edit)
       }
       else{
        history.push(`/bots`);
        window.location.reload()
       }
       
      }
      if (query.rental) {
        setActiveTab(2)
      }
      else if(query.copy) {
        setBotId(query.copy)
      }
      else {
        updatePresetConfig(query);
        setCreateBotModalType(CreateBotModalType.presetConfig);
      }
    } else {
      resetBotConfig();
    }
  }, []);

  const onShowBotDetail = (botId) => {
    setShowBotDetail(botId);
  };
  const onShowBotEdit = (botId) => {
    setLoading(true);
    setCheckClickEdit(true)
    getBotDetail(botId)
        .then((res) => {
          setLoading(false);
          if(!res.rent_id){
            updateEditBotConfig();
            setCreateBotModalType(CreateBotModalType.editBot);
            history.push(`/bots?edit=${botId}`);
          }
          else{
            updateEditRentBotConfig();
            setShowEditRentBotModal(true);
          }
          
        })
        .catch((err) => {
          setLoading(false);
          //toast.error(err);
        });
  };
  const changeTab = (index,tab) => {
    setActiveTab(index);
    getSelectedTab(tab)
    if(index==2){
      getRentalBots(selectedExchangeId,itemsPerPage,pageNum,tab,orderBy,sort)
    }
    else{
      getBots(selectedExchangeId,itemsPerPage,pageNum,tab,orderBy,sort)
    }
    
  };

  const tabs = [
    <Loading {...bindLoading}>
    <BotTab className="active-bots-tour"
      bots={bots}
      startItem={startItem}
      itemsPerPage={itemsPerPage}
      selectedExchangeId={selectedExchangeId}
      pageNum={pageNum}
      selectedTab={selectedTab}
      active={true}
      onShowBotDetail={onShowBotDetail}
      onShowBotEdit={onShowBotEdit}
      orderBy={orderBy}
      sort={sort}
      t={t}
    ></BotTab></Loading>,
    <Loading {...bindLoading}><BotTab className="inactive-bots-tour"
      bots={bots}
      startItem={startItem}
      itemsPerPage={itemsPerPage}
      selectedExchangeId={selectedExchangeId}
      pageNum={pageNum}
      selectedTab={selectedTab}
      active={false}
      onShowBotDetail={onShowBotDetail}
      onShowBotEdit={onShowBotEdit}
      orderBy={orderBy}
      sort={sort}
      t={t}
    ></BotTab></Loading>,
    <Loading {...bindLoading}><BotTabRent className="rented-bots-tour"
      bots={rents}
      startItem={startItemRent}
      itemsPerPage={itemsPerPage}
      selectedExchangeId={selectedExchangeId}
      pageNum={pageNum}
      selectedTab={selectedTab}
      active={false}
      onShowBotDetail={onShowBotDetail}
      t={t}
      orderBy={orderBy}
      sort={sort}
    ></BotTabRent></Loading>,
  ];

  const tabHeaders = tabTitles.map((item, index) => {
    return (
      <Col xs={2} key={index}>
        <a
          className={(index === activeTab ? "tab-active" : "tab-inactive") + " "+ tourClasses[index]}
          onClick={() => changeTab(index,index==0?'active':'inactive')}
        >
          {item}
        </a>
      </Col>
    );
  });

  return (
    <div>
      <ContentContainer url="bots" title={t("bots")} showExchange={true}>
        <div className="bots">
          <div>
            <Row className="mb-1" noGutters>
              <Col xs={12} xl={7}>
                <div>
                  <ProfitPanel
                    exchangeId={selectedExchangeId}
                    onShowCreateDialog={showCreateBotModal}
                    hideGraph={hideGraph}
                    t={t}
                  />
                </div>
              </Col>
              <Col xs={12} xl={5}>
                <div>
                  <DailyPnlPanel
                    height={170}
                    t={t}
                    hideGraph={hideGraph}
                    showHideBtn
                  />
                </div>
              </Col>
            </Row>
          </div>
          {hideGraph && (
            <div className="text-right">
              <button onClick={clickShowGraph} className="show-graph-btn">
                Show Graph &#709;
              </button>
            </div>
          )}

          <div className="round-bg bottom-row" style={{ marginTop: 20,position:'relative' }}>
            <Row noGutters>{tabHeaders}</Row>
           <BotFilterPanel 
            sort={sort}
            setSort={setSort}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            t={t}
            >
            </BotFilterPanel>
            <div className="mt-4">{tabs[activeTab]}</div>
              {/* <div className="bottom-center">
                <CustomPagination
                  itemsCountPerPage={itemsPerPage}
                  selectedExchangeId={selectedExchangeId}
                  startItem={startItem}
                  selectedTab={selectedTab}
                  totalCount={totalBots}
                  onChange={getBots}
                  itemsPerPage={itemsPerPage}
                />
              </div> */}
              <div className="bottom-center">
                {activeTab != 2 ? ( <CustomPagination
                 itemsCountPerPage={itemsPerPage}
                 selectedExchangeId={selectedExchangeId}
                 startItem={startItem}
                 selectedTab={selectedTab}
                 totalCount={totalBots}
                 onChange={getBots}
                 itemsPerPage={itemsPerPage}
                /> ) : 
                (<CustomPagination
                  itemsCountPerPage={itemsPerPage}
                  selectedExchangeId={selectedExchangeId}
                  startItem={startItemRent}
                  selectedTab={selectedTab}
                  totalCount={totalRentBots}
                  onChange={getRentalBots}
                  itemsPerPage={itemsPerPage}
                />) }
              </div>
             
            </div>
            
          
        </div>

        {createBotModalType !== CreateBotModalType.notShow && (
          <CreateBotModal
            modalType={createBotModalType}
            selectedExchangeId={selectedExchangeId}
            pageNum={pageNum}
            itemsPerPage={itemsPerPage}
            selectedTab={selectedTab}
            onHide={() => {
              setCreateBotModalType(CreateBotModalType.notShow);
              window.history.replaceState(null, "", "/bots");
            }}
            orderBy={orderBy}
            sort={sort}
            t={t}
          />
        )}
        {showEditRentBotModal && 
        <CreateBotFromRentModal  
        onHide={()=>setShowEditRentBotModal(false)} 
        edit={true}  selectedExchangeId={selectedExchangeId}
        pageNum={pageNum}
        itemsPerPage={itemsPerPage}
        selectedTab={selectedTab}
        orderBy={orderBy}
        sort={sort}
        ></CreateBotFromRentModal> 
        }

        {showBotDetail != -1 && (
          <BotDetail
            show={showBotDetail != -1}
            onHide={() => {
              setShowBotDetail(-1);
            }}
            itemsPerPage={itemsPerPage}
            selectedExchangeId={selectedExchangeId}
            pageNum={pageNum}
            selectedTab={selectedTab}
            botId={showBotDetail}
            t={t}
          />
        )}
      </ContentContainer>
    </div>
  );
};

export default connect(null, {
  getBots,
  getSubscription,
  updateEditBotConfig,
  updateEditRentBotConfig,
  resetBotConfig,
  updatePresetConfig,
  getIndicators,
  updateCopyBotConfig,
  getBotDetail,
  getRentalBots
})(Bots);
